import { SkeletonProps } from '@mui/joy';

import { InfoBoxRow } from '@components/ui/InfoBox';
import { MapColumnSkeleton } from '@components/ui/skeletons/MapColumnSkeleton';
import { TextColumnSkeleton } from '@components/ui/skeletons/TextColumnSkeleton';

export const InformationSkeleton = ({
  loading,
  children,
  map,
  oneTextColumn,
}: SkeletonProps & { map?: boolean; oneTextColumn?: boolean }) => {
  if (loading) {
    return (
      <InfoBoxRow>
        <TextColumnSkeleton sx={{ flex: map ? 5 : 1 }} />
        {map && !oneTextColumn ? (
          <MapColumnSkeleton sx={{ flex: 4 }} />
        ) : !map && !oneTextColumn ? (
          <TextColumnSkeleton />
        ) : null}
      </InfoBoxRow>
    );
  }

  return children;
};
